export const sendMetrik = (type: string, value: string) => {
    const counter = 99975029;
    window.ym(counter, type, value);
    console.log(counter, type, value);
}